/**
 * @file Types et limites des questions personnalisées du formulaire de réservation.
 * @module common.constants.restaurants.customQuestions
 *
 * Miroir du fichier backend
 * backend/src/modules/restaurants/constants/customQuestions.js : les clés de type
 * sont stockées en base, sur la configuration et sur chaque réponse, et ne
 * doivent jamais être renommées. Le serveur reste juge des limites ; elles sont
 * reprises ici pour guider la saisie.
 */

/**
 * Types de question. Le type décide de la forme de la réponse attendue.
 *
 * @constant {Object}
 * @property {string} TEXT - Réponse écrite libre
 * @property {string} YES_NO - Choix explicite Oui ou Non (« Non » est une réponse)
 * @property {string} CHECKBOX - Case à cocher, typiquement une prise de connaissance
 */
export const CUSTOM_QUESTION_TYPES = Object.freeze({
  TEXT: 'text',
  YES_NO: 'yes_no',
  CHECKBOX: 'checkbox',
});

/**
 * Icône de chaque type, seule table source pour le widget, le site public et le
 * backoffice. La case à cocher n'a pas d'en-tête dans les formulaires (la case
 * sert de repère) ; sa coche marque les prises de connaissance dans le détail.
 */
export const CUSTOM_QUESTION_ICONS = Object.freeze({
  [CUSTOM_QUESTION_TYPES.YES_NO]: 'mdi:help-circle-outline',
  [CUSTOM_QUESTION_TYPES.TEXT]: 'mdi:message-text-outline',
  [CUSTOM_QUESTION_TYPES.CHECKBOX]: 'mdi:check',
});

/** Libellés des types dans les réglages, dans l'ordre du sélecteur. */
export const CUSTOM_QUESTION_TYPE_OPTIONS = Object.freeze([
  {value: CUSTOM_QUESTION_TYPES.YES_NO, label: 'Oui / Non'},
  {value: CUSTOM_QUESTION_TYPES.CHECKBOX, label: 'Case à cocher'},
  {value: CUSTOM_QUESTION_TYPES.TEXT, label: 'Texte libre'},
]);

/** Au-delà, l'étape de détails devient un questionnaire que le client abandonne. */
export const MAX_CUSTOM_QUESTIONS = 5;

/** Une question tient en une phrase ou deux. */
export const CUSTOM_QUESTION_LABEL_MAX_LENGTH = 300;

/** Même ordre de grandeur que les demandes spéciales. */
export const CUSTOM_ANSWER_TEXT_MAX_LENGTH = 500;

/** Code du refus serveur quand une question obligatoire est restée sans réponse. */
export const CUSTOM_ANSWERS_REQUIRED_CODE = 'CUSTOM_ANSWERS_REQUIRED';
